import React from 'react'
import { useAuthProvider, authContext } from "../hooks/useAuth";

const { Provider } = authContext;

export function AuthProvider({ children }) {
    const auth = useAuthProvider();
    return <Provider value={auth}>{!auth.isLoading && children}</Provider>;
}